import useSWR from "swr"
import { useSmoothApi } from "src/hooks/useSmoothApi"
import { SMOOTH_LINE_API_URL } from "src/lib/constants"
import { AutoAcquisitionAccountsApiResponse, UseGetAutoAcquisitionAccountsReturn } from "../types"

const AUTO_ACQUISITION_ACCOUNTS_URL = `${SMOOTH_LINE_API_URL}/base_api/smoother/screen/auto_acquisition_accounts`

/**
 * AutoAcquisitionAccountの一覧を取得するカスタムフック
 */
export const useGetAutoAcquisitionAccounts = (): UseGetAutoAcquisitionAccountsReturn => {
  const { getWithToken } = useSmoothApi()

  /**
   * データ取得用のfetcher関数
   * @returns APIレスポンス
   */
  const fetcher = async (): Promise<AutoAcquisitionAccountsApiResponse> => {
    try {
      const response = await getWithToken(AUTO_ACQUISITION_ACCOUNTS_URL)
      return response.data as AutoAcquisitionAccountsApiResponse
    } catch (error) {
      console.error("AutoAcquisitionAccountの取得に失敗しました:", error)
      throw error
    }
  }

  const { data, error, mutate } = useSWR<AutoAcquisitionAccountsApiResponse>(
    AUTO_ACQUISITION_ACCOUNTS_URL,
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
      // dedupingInterval: 0, // 必要に応じて設定
    }
  )

  const refresh = async () => {
    return mutate(undefined, { revalidate: true })
  }

  return {
    autoAcquisitionAccounts: data?.autoAcquisitionAccounts ?? [],
    isLoading: !error && !data,
    error: error ?? null,
    mutate,
    refresh,
  }
}
